var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-calendar.3b2d7787.png","uri@2x": __webpack_public_path__ + "icon-calendar.a72b8b6e.png","uri@3x": __webpack_public_path__ + "icon-calendar.95511636.png",
    width: 20,
    height: 20
});